import Vue from 'vue'
import VueRouter from 'vue-router'
//import { getCookie, getAllCookies, removeCookie } from 'tiny-cookie';
//import { iStorage, simulatorBus } from '@/core';
import NProgress from 'nprogress';
import "nprogress/nprogress.css";

Vue.use(VueRouter)

const routes = [{
		path: '/report',
		name: 'report',
		component: () => import('@/views/report')
	},
	{
		path: '/echarts',
		name: 'echarts',
		component: () => import('@/views/echarts')
    },
    {
		path: '/reportChart',
		name: 'reportChart',
		component: () => import('@/views/car')
	},
	{
		path: '/reportByUser',
		name: 'reportByUser',
		component: () => import('@/views/car/reportByUser')
	},
	{
		path: '/reportByExtNum',
		name: 'reportByExtNum',
		component: () => import('@/views/car/reportByExtNum')
	},
	{
		path: '/reportBySupplier',
		name: 'reportBySupplier',
		component: () => import('@/views/car/reportBySupplier')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	NProgress.start();
	next();
	//	let token = getCookie("token");
	//	let Uris = getCookie("Uris");
	//
	//	if(token && Uris) {
	//		next();
	//	} else {
	//		iStorage.clear();
	//		console.log('当前域名：' + document.domain)
	//		console.log('主域名：' + window.idomain)
	//		var allCookies = getAllCookies();
	//
	//		Object.keys(allCookies).forEach(function(key) {
	//			removeCookie(key, {
	//				domain: window.idomain
	//			});
	//			removeCookie(key, {
	//				domain: document.domain
	//			});
	//		});
	//		simulatorBus.openiaccount();
	//	}
});

router.afterEach(() => {
	NProgress.done();
})

export default router